module.exports = __webpack_public_path__ + "img/rep-answer.cba714f1.svg";